import React from 'react'
import Head from 'next/head'
import AppBar from 'Components/AppBar'
import { connect } from 'react-redux'
import { AppContext } from 'Utils/withReduxStore'
import Markdown from 'react-markdown'
import Breadcrumb from 'Components/Breadcrumb'
import { ViewType as AppBarViewType } from 'Components/AppBar/AppBar'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import prnt from 'Scss/pages/article.scss'
import plph from 'Components/ProductListPage/components/ProductListPageHeader/ProductListPageHeader.scss'
import { CodeRenderer, LinkRenderer } from 'Utils/helpers/markDownRenderers'
import { redirect, goBack } from 'Utils/helpers/routerHelper'
import cmsContentQuery from 'Utils/api/gql/queries/cmsContent'
import { Query } from 'react-apollo'
import { cmsContent, cmsContent_cmsContent } from 'Utils/api/gql/types'
import LoadingPage from 'Components/LoadingPage'
import Footer from 'Components/Footer'
import Error from './_error'
import has from 'lodash/has'
import { SVGArrowBack } from 'Components/SVGCollection'
import { BreadcrumbData, formatBreadcrumbForGtm } from 'Components/Breadcrumb/Breadcrumb';
import { isServer } from 'Utils/debugUtils';
import axios from 'axios'

type PropType = {
    url_key: string
}

class ArticlePage extends React.Component<PropType> {
    static async getInitialProps({ query, res, initialState, req }: AppContext): Promise<Partial<PropType>> {
        if (!query.url_key) {
          redirect('/', res)
          return { }
        }

        let url_key = typeof query.url_key === 'string'
          ? query.url_key
          : query.url_key[0]

        const path = `/cikk/${url_key}`
        let urlAliases = initialState.scheduledData.urlAliases || null
        if (isServer()) {
            if (urlAliases === null && req.scheduledData && req.scheduledData.urlAliases) {
                urlAliases = req.scheduledData.urlAliases
            }
            const foundAlias = urlAliases.find(alias => { return path.substr(path.length - 1, 1) !== '/' ? alias.source_url === path || alias.source_url === `${path}/` : alias.source_url === path })
            if (foundAlias && (foundAlias.target_url !== path)) {
                redirect(foundAlias.target_url, res)
                return {}
            }
        } else {
            if (urlAliases === null) {
                const result = await axios.get(`/local/alias?url=${encodeURIComponent(path)}`)
                if (result.data && result.data.redirectTo && result.data.redirectTo !== null) {
                redirect(result.data.redirectTo, res)
                return { }
                }
            }
        }

        return { url_key }
    }

    renderContent = (article: cmsContent_cmsContent) => {
        const breadcrumbData: BreadcrumbData[] = [
            {
              href: '/',
              title: 'Főoldal',
              gtmName: 'Home'
            },
            {
              href: `/cikk/${this.props.url_key}`,
              title: article.title,
              gtmName: `Article / ${article.title}`
            }
        ]

        return (
            <div>
                <Head>
                    <title>{article.meta_title || article.title}</title>
                    <meta name="description" content={article.meta_description || ''} />
                    <meta name="keywords" content={article.meta_keywords || ''} />
                </Head>

                <AppBar
                    viewType={AppBarViewType.SubPage}
                    pageTitle={article.title}
                    breadcrumb={formatBreadcrumbForGtm(breadcrumbData)}
                    pageType="Home"
                 />

                <div className={cn(cg.gridContainer, prnt.articlePage__mainContainer)}>

                    <div className={cn(cg.showForMedium, prnt.articlePage__breadcrumbContainer)}>
                        <Breadcrumb data={breadcrumbData} />
                    </div>

                    <div className={cn(cg.gridX, plph.productListPage__header, cg.showForLarge)}>
                        <div className={cn(cg.cell, cg.shrink)}>
                            <a className={plph.linkBack} onClick={goBack}>
                            <span className={cg.showForSr}>
                                Vissza
                            </span>

                            <span aria-hidden="true">
                                <SVGArrowBack width="32" height="32" />
                            </span>
                            </a>
                        </div>
                        <div className={cn(cg.cell, cg.auto)}>
                            <h1 className={plph.h1}>
                                {article.title}
                            </h1>
                        </div>
                    </div>
                    <div className={cn(prnt.articleContent)}>
                        <Markdown
                            renderers={{
                                code: CodeRenderer,
                                link: LinkRenderer
                            }}
                        >
                            {article.content}
                        </Markdown>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }


    render() {
        return (
            <Query<cmsContent>
                query={cmsContentQuery}
                variables={{url_key: this.props.url_key}}
                partialRefetch={true}
            >
                {({ error, data, refetch }) => {
                    if (error) {
                        if (has(error, 'graphQLErrors.0.extensions.validation.url_key')) {
                            return <Error statusCode={404} />
                        } else {
                            return <Error statusCode={500} />
                        }
                    }

                    if (data && data.cmsContent) {
                            return this.renderContent(data.cmsContent)
                    }

                    return <LoadingPage />
                }}
            </Query>
        );

    }
}

const mapStateToProps = ({ session }: Redux.IReduxState) => ({
    session
})

export default connect(mapStateToProps)(ArticlePage)
